Ext.define('SA.model.SeriesLocation', {
    extend: 'SA.model.LocationItem',

    constructor({id, censusReleaseYears, geoUnitId, alias}) {
        this.callParent(arguments);

        this.id = id;
        this.censusReleaseYears = censusReleaseYears;
        this.geoUnitId = geoUnitId;
        this.alias = alias;
    },

    getAlias() {
        return this.alias;
    },

    getGeoUnitId() {
        return this.geoUnitId;
    },

    getId() {
        return this.id;
    },

    getStringId() {
        return this.getId();
    },

    hasAlias() {
        return Ext.isString(this.getAlias());
    },

    hasCensusReleaseYear(censusReleaseYear) {
        return this.censusReleaseYears.includes(censusReleaseYear);
    },

    toItem() {
        return {type: 'locationSeries', id: this.getId()};
    }
});